/**
 * THE BUILT-IN ADMIN (spec Q37, Q45; glossary: Built-in admin) — one rule for the whole editor: the entity page,
 * the entity chat and the Roles tab ask it. The server's reserved `admin` role may do everything with every
 * entity, and its permissions can't be changed (manageRole refuses with 409). Pure.
 */
export const BUILT_IN_ADMIN_ID = 'admin';

export function isFullAccessRole(role: { id: string; reserved?: boolean }): boolean {
  return role.reserved === true || role.id === BUILT_IN_ADMIN_ID;
}

/** Whether any role other than the built-in admin exists (plan 4d, Q44 — the Add Role empty state). */
export function hasOrdinaryRoles(roles: readonly { id: string; reserved?: boolean }[]): boolean {
  return roles.some((r) => !isFullAccessRole(r));
}
